import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useConversation } from '@/hooks/api'
import { LoadingSpinner } from '@/components/common'

/**
 * Redirects from a Twilio conversation ID to the actual conversation page.
 * Used to maintain backwards compatibility with old frontend URLs like:
 * /#/conversations/redirect/{twilio_id}
 *
 * The backend's ReactAdmin getOne endpoint automatically handles
 * twilio_id lookup when the ID matches the Twilio resource ID format.
 */
export function ConversationRedirectPage() {
  const { twilioId } = useParams<{ twilioId: string }>()
  const navigate = useNavigate()

  // The backend's raClient.getOne will automatically look up by twilio_id
  // if the ID matches the Twilio resource ID format (e.g., CA...)
  const { data, isLoading, error } = useConversation(twilioId)

  useEffect(() => {
    if (data?.id) {
      // Redirect to the actual conversation page
      navigate(`/conversations/${data.id}/overview`, { replace: true })
    } else if (error || (!isLoading && !data)) {
      // If conversation not found or error, redirect to conversations list
      navigate('/conversations', { replace: true })
    }
  }, [data, error, isLoading, navigate])

  // Show loading spinner while fetching
  return (
    <div className="flex h-full items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  )
}
